import { render, staticRenderFns } from "./EmployeeBranchForm.vue?vue&type=template&id=ff20f70c&"
import script from "./EmployeeBranchForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports